export default function PageNotFoundPage() {
  return (
    <div className="flex justify-center items-center h-screen">
      <h1 className="text-5xl font-bold">404 Page Not Found</h1>
    </div>
  );
}
